import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { Box } from '../Box';
import { Text } from '../Text';

export const NoOverflowBox = styled(Box)`
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
`;

export const ImageWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile'
})<{ isMobile?: boolean }>`
  & > img,
  & > span > img {
    border-radius: ${({ theme, isMobile = false }) =>
      isMobile ? theme.borderRadius.block : theme.borderRadius.block_desktop};
  }

  display: ${({ isMobile = false }) =>
    isMobile ? 'block' : 'none'} !important;

  ${mediaQueries.tablet} {
    display: ${({ isMobile = false }) =>
      isMobile ? 'none' : 'block'} !important;
  }
`;

export const HeadingText = styled(Text)`
  text-align: center;
  width: 100%;

  ${mediaQueries.tablet} {
    text-align: left;
  }
`;

export const Copy = styled('div')`
  text-align: center;

  &:last-child > a {
    margin-top: ${pxToRem(17)};
  }

  ${mediaQueries.tablet} {
    text-align: left;
  }
`;
